export function debounce(func, wait, options = {}) {
  const { maxWait } = options;
  let timeoutId;
  let maxTimeoutId;
  let lastInvokeTime = 0;
  let lastArgs;
  let lastThis;

  function invoke() {
    lastInvokeTime = Date.now();
    clearTimeout(maxTimeoutId);
    maxTimeoutId = undefined;
    return func.apply(lastThis, lastArgs);
  }

  function debounced(...args) {
    const now = Date.now();
    if (
      maxWait != null &&
      timeoutId === undefined &&
      maxTimeoutId === undefined
    ) {
      lastInvokeTime = now;
    }
    lastArgs = args;
    lastThis = this;
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      timeoutId = undefined;
      invoke();
    }, wait);

    if (maxWait != null) {
      const timeSinceLastInvoke = now - lastInvokeTime;
      if (timeSinceLastInvoke >= maxWait) {
        clearTimeout(timeoutId);
        timeoutId = undefined;
        clearTimeout(maxTimeoutId);
        maxTimeoutId = undefined;
        return invoke();
      }

      if (maxTimeoutId === undefined) {
        maxTimeoutId = setTimeout(() => {
          clearTimeout(timeoutId);
          timeoutId = undefined;
          maxTimeoutId = undefined;
          invoke();
        }, maxWait - timeSinceLastInvoke);
      }
    }
  }

  debounced.cancel = () => {
    clearTimeout(timeoutId);
    clearTimeout(maxTimeoutId);
    timeoutId = undefined;
    maxTimeoutId = undefined;
    lastInvokeTime = 0;
    lastArgs = lastThis = undefined;
  };

  return debounced;
}
